import React from 'react';

import Icon from '../../../components/AppIcon';

const LandingFooter = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    product: [
      { label: 'Características', href: '#features' },
      { label: 'Precios', href: '#contact' },
      { label: 'Documentación', href: '#' },
      { label: 'API', href: '#' }
    ],
    company: [
      { label: 'Acerca de', href: '#' },
      { label: 'Blog', href: '#' },
      { label: 'Carreras', href: '#' },
      { label: 'Contacto', href: '#contact' }
    ],
    legal: [
      { label: 'Términos de Servicio', href: '#' },
      { label: 'Política de Privacidad', href: '#' },
      { label: 'Aviso de Privacidad', href: '#' },
      { label: 'Cumplimiento', href: '#' }
    ],
    support: [
      { label: 'Centro de Ayuda', href: '#' },
      { label: 'Soporte Técnico', href: '#' },
      { label: 'Estado del Sistema', href: '#' },
      { label: 'Reportar un Problema', href: '#' }
    ]
  };

  const socialLinks = [
    { icon: 'Facebook', href: '#', label: 'Facebook' },
    { icon: 'Twitter', href: '#', label: 'Twitter' },
    { icon: 'Linkedin', href: '#', label: 'LinkedIn' },
    { icon: 'Instagram', href: '#', label: 'Instagram' }
  ];

  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 mb-8">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg">
                <Icon name="Car" size={24} color="white" />
              </div>
              <div className="flex flex-col">
                <span className="text-xl font-semibold text-foreground">VIN Pro</span>
                <span className="text-xs text-muted-foreground -mt-1">Platform</span>
              </div>
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              Plataforma profesional de consultoría de VIN para la industria automotriz en México.
            </p>
            {/* Social Links */}
            <div className="flex items-center space-x-3">
              {socialLinks?.map((social, index) => (
                <a
                  key={index}
                  href={social?.href}
                  aria-label={social?.label}
                  className="flex items-center justify-center w-9 h-9 bg-muted rounded-md hover:bg-primary hover:text-primary-foreground transition-smooth"
                >
                  <Icon name={social?.icon} size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">Producto</h3>
            <ul className="space-y-2">
              {footerLinks?.product?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.href}
                    className="text-sm text-muted-foreground hover:text-foreground transition-smooth"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">Empresa</h3>
            <ul className="space-y-2">
              {footerLinks?.company?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.href}
                    className="text-sm text-muted-foreground hover:text-foreground transition-smooth"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">Legal</h3>
            <ul className="space-y-2">
              {footerLinks?.legal?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.href}
                    className="text-sm text-muted-foreground hover:text-foreground transition-smooth"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">Soporte</h3>
            <ul className="space-y-2">
              {footerLinks?.support?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.href}
                    className="text-sm text-muted-foreground hover:text-foreground transition-smooth"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <div className="text-sm text-muted-foreground text-center md:text-left">
              © {currentYear} VIN Pro Platform. Todos los derechos reservados.
            </div>
            <div className="flex items-center space-x-6">
              <div className="flex items-center space-x-2 text-xs text-muted-foreground">
                <Icon name="Shield" size={14} className="text-success" />
                <span>Certificado ISO 27001</span>
              </div>
              <div className="flex items-center space-x-2 text-xs text-muted-foreground">
                <Icon name="Lock" size={14} className="text-success" />
                <span>Datos Protegidos</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;